const FADE_DURATION_MS = 100;
const ASIDE_CONTENT_FADE_DURATION_MS = 200;
const revisionButtonFadeDurationMs = 100;
const wrapperCls = "_61wbeluc3";
const buttonCls = "_61b27ku9i";
const iconCls = "_61iqy80xq";
const crossIcon = "_61c1xfdjym";
const navigationCls = "_61ngbj6pp";
const scrollerCls = "_61s1ie4uhi";
const revisionsWrapper = "_61ri6of36";
const pillCls = "_61pnhyao0";
const srCloseButton = "_61synls5v";

export { ASIDE_CONTENT_FADE_DURATION_MS, FADE_DURATION_MS, buttonCls, crossIcon, iconCls, navigationCls, pillCls, revisionButtonFadeDurationMs, revisionsWrapper, scrollerCls, srCloseButton, wrapperCls };
import "./sub-navigation.style.linaria.module.css";
//# sourceMappingURL=sub-navigation.style.js.map
